/* TEST */
export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const GET_EMPLOYEES_SUCCESS = "GET_EMPLOYEES_SUCCESS";
export const GET_PARTS = "GET_PARTS";
export const GET_PARTS_SUCCESS = "GET_PARTS_SUCCESS";
export const GET_COMPANIES = "GET_COMPANIES";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_CARE_COMPANIES = "GET_CARE_COMPANIES";
export const GET_CARE_COMPANIES_SUCCESS = "GET_CARE_COMPANIES_SUCCESS";
export const GET_GRADES = "GET_GRADES";
export const GET_GRADES_SUCCESS = "GET_GRADES_SUCCESS";
export const GET_GROUPS = "GET_GROUPS";
export const GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS";
export const GET_UNREAD_NOTIFICATION_COUNT = "GET_UNREAD_NOTIFICATION_COUNT";
export const GET_UNREAD_NOTIFICATION_COUNT_SUCCESS = "GET_UNREAD_NOTIFICATION_COUNT_SUCCESS";
export const API_ERROR = "API_ERROR";
export const FULL_SIZE_LOADING = "FULL_SIZE_LOADING";
export const ALERT = "ALERT";
export const TRIAL = "TRIAL";
export const TRIAL_REQUEST_PARTNERS = "TRIAL_REQUEST_PARTNERS";
export const CONSULTING = "CONSULTING";

export const CMS_REGISTRATION = "CMS_REGISTRATION";

export const PRINT_PAGE = "PRINT_PAGE";

export const TAX_ACCOUNTANT_USEFUL_SITE = "TAX_ACCOUNTANT_USEFUL_SITE";

export const GET_TAXPAYER_LIST = "GET_TAXPAYER_LIST"
export const GET_TAXPAYER_LIST_SUCCESS = "GET_TAXPAYER_LIST_SUCCESS"
export const POPUP_TOGGLE = "POPUP_TOGGLE";
